export const SELECT_PLACEHOLDER_TEXT = 'Select session date and time';

export const TestID = 'ReportedCoachingVisitSelector.TestID';
